import React, { useState } from 'react';
import { Fragment } from 'react';
import { BrowserRouter as Router, Link, Route } from 'react-router-dom';
import Logo from './NavImages/logo.png'
import './nav.css';
// import AccountCircleIcon from '@material-ui/icons/AccountCircle';


function Nav() {
    const [click, setClick] = useState(false);
    const [navbar, setNavbar] = useState(false);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const changeBackground = () => {
        if (window.scrollY >= 80) {
            setNavbar(true)
        } else {
            setNavbar(false)
        }
    }
    window.addEventListener('scroll', changeBackground);

    return (
        <Fragment>
            <nav className={navbar ? 'navbar active' : 'navbar'}>
                <div className="navbar-container">
                    <Link to='/'
                        className="navbar-logo"
                        onClick={closeMobileMenu}>
                        <img src={Logo} alt="" width="80" height="80" />
                        <h6 className="nav-logo-txt">WeShare</h6>
                    </Link>
                </div>
                <div className="menu-icon" onClick={handleClick}>
                    <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
                </div>
                <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                    <li className="nav-item">
                        <Link to='/' className="nav-links" onClick={closeMobileMenu}>
                            Beranda
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to='/ayo-donasi' className="nav-links" onClick={closeMobileMenu}>
                            Ayo Donasi
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to='/buka-donasi' className="nav-links" onClick={closeMobileMenu}>
                            Buka Donasi
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to='/tentang-kami' className="nav-links" onClick={closeMobileMenu}>
                            Tentang Kami
                        </Link>
                    </li>
                    <button className="navbar-btn1">
                        <Link to='/masuk' className="nav-links" onClick={closeMobileMenu}>
                            Masuk
                        </Link>
                    </button>
                    <button className="navbar-btn2">
                        <Link to='/daftar' className="nav-links" onClick={closeMobileMenu}>
                            Daftar
                        </Link>
                    </button>
                    {/* <div className="user">
                        <Link to="/user-dashboard">
                            <AccountCircleIcon />
                        </Link>
                    </div> */}
                </ul>
            </nav>
        </Fragment >
    )
}

export default Nav;